import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import "./index.css";
import "./theme.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AnimatePresence } from "framer-motion";
import { store } from "./app/store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <AnimatePresence mode="wait">
      <App />
    </AnimatePresence>
  </Provider>
);

reportWebVitals();
